<template>
  <div class="integral-order-wrap">
    <div class="exchange-wrap">
      <div class="title">积分兑换</div>
      <div class="address">
        <div class="title">确认收货地址</div>
        <div class="address-list">
          <el-radio-group v-model="addressId">
            <el-radio class="item" :label="item.id" v-for="(item, index) in addressList" :key="item.id">
              {{ item.province }} {{ item.city }} {{ item.district }} {{ item.detail }} （{{ item.name }} 收）{{ item.phone
              }}
            </el-radio>
          </el-radio-group>
        </div>
        <div class="addAddress" @click="showAddAddressForm = true">{{ addressList.length ? '使用其他地址' : '添加收货地址' }}</div>
      </div>
      <div class="confirm-order">
        <div class="title">确认订单信息</div>
        <div class="table-wrap">
          <el-table :data="productList" v-loading="loading" element-loading-text="给我一点时间" :empty-text="emptyText" border
            fit highlight-current-row>
            <el-table-column label="商品名称" align="center" minWidth="150" prop="name">
            </el-table-column>
            <el-table-column label="积分数量" align="center" minWidth="150">
              <template slot-scope="{row}">
                <span>{{ row.integral_price }}积分</span>
              </template>
            </el-table-column>
            <el-table-column label="数量（件）" align="center" minWidth="150">
              <template slot-scope="{row}">
                <span>{{ row.num }}</span>
              </template>
            </el-table-column>
            <el-table-column label="积分小记" align="center" minWidth="180">
              <template slot-scope="{row}">
                <span>{{ row.amount }}积分</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="operate-wrap">
          <div class="integral-num">当前可用积分：{{ user.integral || 0 }}</div>
          <el-button class="my-btn" @click="handleAddOrder" :loading="loading">确认兑换</el-button>
        </div>
      </div>
    </div>
    <!-- 新建地址 -->
    <add-address :visible.sync="showAddAddressForm" @getList="getAddressList" />
  </div>
</template>

<script>

import { getOrderPreview, addOrder } from "@/api/order";
import { getAllAddressList } from "@/api/address";
import AddAddress from "../user/components/addAddress"
export default {
  name: "StoreOrderIntegral",
  components: {
    AddAddress
  },
  props: {},
  data() {
    return {
      showAddAddressForm: false,
      addressList: [],
      loading: true,
      emptyText: '暂无数据',
      productId: 0,
      order: {},
      addressId: 0,
      user: {},
      productList: [],
      model: 'integral',
      group: 'store',
    }
  },
  computed: {

  },
  created() {
    this.productId = this.$route.query.id
    this.getOrderPreview()
    this.getAddressList()
  },
  mounted() {
    this.formatPrice = this.utils.formatPrice
  },
  updated() {

  },
  methods: {
    getOrderPreview() {
      getOrderPreview({ product_id: this.productId }).then(res => {
        this.productList = res.data.productList.map(item => {
          item.num = 1;
          item.amount = parseInt(item.integral_price) * item.num;
          return item;
        });
        console.log(this.productList)
        this.user = res.data.user;
        this.loading = false;
      }).catch((err) => {

      });
    },
    getAddressList() {
      getAllAddressList({}).then(res => {
        this.addressList = res.data;
        this.addressId = res.data ? res.data[0].id : 0;
        this.loading = false;
      }).catch((err) => {

      });
    },
    handleShowAddAddress() {
      this.showAddAddressForm = true;
    },
    // 提交订单
    handleAddOrder() {
      // 验证form表单
      if (!this.addressId) {
        this.$message.error('请选择收货地址!');
        return false;
      }
      if (!this.productId) {
        this.$message.error('参数错误!');
        return false;
      }
      const _form = {
        product_id: this.productId,
        address_id: this.addressId,
        model: this.model,
        group: this.group,
      };
      this.loading = true;
      addOrder(_form).then((response) => {
        this.loading = false;
        // 弹出操作提示
        this.$message({
          type: 'success',
          message: '兑换成功!'
        }); setTimeout(() => {
          this.$router.push({
            path: '/user/order/list/store'
          })
        }, 500);
      }).catch(() => {
        this.loading = false;
      });

    },
  }
};
</script>
<style lang="scss" scoped>
.integral-order-wrap {
  width: 100%;
  padding-top: 20px;
  padding-bottom: 56px;
  background: #F4F8F9;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;

  .exchange-wrap {
    width: 1200px;
    background: #FFFFFF;
    box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.0196);
    padding: 0 15px 121px 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: column;

    &>.title {
      width: 100%;
      padding: 32px 0 15px 0;
      box-sizing: border-box;
      font-size: 20px;
      font-weight: 400;
      color: #222222;
      text-align: center;
      border-bottom: 1px solid #CCD7DB;
    }

    .address {
      width: 100%;
      padding: 25px 28px 64px 28px;
      box-sizing: border-box;

      &>.title {
        font-size: 20px;
        font-weight: 400;
        color: #6F7F84;
      }

      .address-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 0 175px;
        box-sizing: border-box;
        margin-top: 27px;
        row-gap: 20px;

        .item {
          width: 100%;
          display: flex;
          align-items: center;
          column-gap: 10px;
          font-size: 14px;
          font-weight: 300;
          color: #333333;
          margin-top: 10px;
        }
      }

      .addAddress {
        margin-top: 20px;
        margin-left: 218px;
        font-size: 14px;
        font-weight: 300;
        color: #00B4E8;
        cursor: pointer;
      }
    }

    .confirm-order {
      padding-top: 58px;
      width: 100%;
      border-top: 1px solid #CCD7DB;

      &>.title {
        font-size: 20px;
        font-weight: 400;
        color: #6F7F84;
        padding-left: 25px;
        margin-bottom: 15px;
      }

      .price {
        font-size: 20px;
        font-weight: bold;
        color: #FF6666;
      }

      .operate-wrap {
        width: 100%;
        display: flex;
        flex-direction: column;
        row-gap: 19px;
        align-items: flex-end;
        margin-top: 17px;

        .integral-num {
          width: 166px;
          font-size: 14px;
          font-weight: 400;
          color: #A0A9AC;
          text-align: center;
        }
      }
    }
  }
}
</style>
